import React, {useState} from 'react';
import {Pressable, StyleSheet, View} from 'react-native';

import SlideModal from '@/Atoms/SlideModal';
import CCText from '@/Atoms/CCText';
import CCColors from '@/Utils/CCColors';
import {FontSizes} from '@/Utils/Dimensions';

import RoyaleSettings from '@/Screens/FunChallenges/components/RoyaleSettings';
import {DEFAULT_ROYALE_SETTINGS} from '@/Screens/FunChallenges/royaleConstants';
import type {RoyaleSettings as RoyaleSettingsValue} from '@/Screens/FunChallenges/royaleTypes';

const TEAL = '#3DAB9E';

interface Props {
  visible: boolean;
  onClose: () => void;
  /** Fires with the chosen settings when the coach taps Create Puzzle Royale. */
  onCreate: (settings: RoyaleSettingsValue) => void;
}

/**
 * Coach-facing modal in the classroom: shows the full Puzzle Royale options
 * (topics / time / difficulty / punish) AND the Create button in the same
 * sheet. On Create we hand the settings back; the classroom screen stashes them
 * and opens the royale lobby in a new tab to actually create the lobby + notify
 * students.
 */
export default function RoyaleCreateModal({visible, onClose, onCreate}: Props) {
  const [settings, setSettings] = useState<RoyaleSettingsValue>(
    DEFAULT_ROYALE_SETTINGS,
  );

  return (
    <SlideModal
      visible={visible}
      onClose={onClose}
      modalHeaderTitle="Create Puzzle Royale"
      type="center"
      contentPadding={20}>
      <View style={styles.body}>
        <RoyaleSettings value={settings} onChange={setSettings} />
        <Pressable
          onPress={() => onCreate(settings)}
          style={styles.createBtn}>
          <CCText
            fontSize={FontSizes[14]}
            fontWeight={600}
            color={CCColors.White}>
            Create Puzzle Royale
          </CCText>
        </Pressable>
      </View>
    </SlideModal>
  );
}

const styles = StyleSheet.create({
  body: {
    gap: 16,
  },
  createBtn: {
    backgroundColor: TEAL,
    paddingVertical: 12,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
